import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { useEffectOnce } from '@chilecompra/react-kit'
import { Root, LeftBar, RightBar, Strong, Typography } from './DualBarChart.styles'

/**
 * The DualBarChart's component.
 */
const DualBarChart = props => {
  const { margin, NoContract, WithContract, activeBar, handleContract, handleNoContract } = props
  const rootRef = useRef(null)
  const [maxWidth, setMaxWidth] = useState('100%')

  useEffectOnce(() => {
    setMaxWidth(`${rootRef.current.offsetWidth - 200}px`)
  })

  return (
    <Root margin={margin} ref={rootRef}>
      <LeftBar activeBar={activeBar} maxWidth={maxWidth} percentage={WithContract.percentage} onClick={handleContract}>
        <Typography
          align="left"
          alignItems="center"
          color="white"
          display="flex"
          fontSize="14px"
          lineHeight="46px"
          padding="0 0 0 20px"
          variant="body2"
        >
          <Strong>{WithContract.value}&nbsp;</Strong> con ficha de contrato
        </Typography>
      </LeftBar>
      <RightBar
        activeBar={activeBar}
        left={WithContract.percentage}
        maxWidth={maxWidth}
        percentage={NoContract.percentage}
        onClick={handleNoContract}
      >
        <Typography align="right" color="white" fontSize="14px" lineHeight="46px" padding="0 20px 0 0" variant="body2">
          <Strong>{NoContract.value}&nbsp;</Strong> sin ficha de contrato
        </Typography>
      </RightBar>
    </Root>
  )
}

DualBarChart.defaultProps = {
  margin: '0'
}

DualBarChart.propTypes = {
  activeBar: PropTypes.string.isRequired,
  margin: PropTypes.string,
  NoContract: PropTypes.shape({
    idEntity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    percentage: PropTypes.number,
    type: PropTypes.string,
    value: PropTypes.number,
    year: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  WithContract: PropTypes.shape({
    idEntity: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    percentage: PropTypes.number,
    type: PropTypes.string,
    value: PropTypes.number,
    year: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  handleContract: PropTypes.func,
  handleNoContract: PropTypes.func
}

export default DualBarChart
